import { make } from 'vuex-pathify'

const state = () => ({
  data: {}
})

const mutations = make.mutations(state)

export default {
  namespaced: true,
  state,
  mutations
}
